import { ObjectField } from 'react3l-decorators';
import nameof from 'ts-nameof.macro';
import { ExternalServiceApi } from 'models/ExternalServiceApi';
import { LoggingApi } from './LoggingApi';


ObjectField(ExternalServiceApi)(LoggingApi.prototype, nameof(LoggingApi.prototype.externalServiceApi));


export * from './LoggingApi';
export * from './LoggingApiFilter';


